/* MATLEON — Brocha (vanilla, sin librerías)
   Pinta una imagen (la M del logo) pincelada por pincelada, como una brocha de verdad, y al final le pasa una franja
   de luz. Lo usan la tienda (mt-movimiento.js, cierre) y la herramienta de videos (herramientas/video/brocha.mjs),
   así que la M se ve igual en la página y en los videos.

   Cómo funciona:
   - La imagen está dentro de un <svg data-mt-brocha> con una máscara. Cada pincelada es un <path class="mt-brocha__t">
     de la máscara: su camino central y su grosor (stroke-width), en el orden en que una mano la pinta.
     data-remate = latigazo corto después de levantar la brocha (el pie de abajo de la M).
     data-sale = en qué parte de la pincelada anterior arranca esta (0.66 si no se pone).
     data-suelta = la brocha se va levantando al final: más pausada, frena suave y la punta queda deshilachada.
   - Cada pincelada se cambia por un manojo de CERDAS: caminos paralelos que cubren el mismo ancho, cada una con su
     grosor. Las del centro van un poco adelante y las de la orilla atrás, con pequeñas diferencias: la punta de la
     pincelada queda deshilachada como la de una brocha (no redonda como un plumón).
   - Ritmo de mano: la brocha cae, acelera y frena al llegar a la esquina; la siguiente pincelada sale justo antes de
     que la anterior termine. Los remates salen tras levantar la brocha, rápidos.
   - Al final se destapa la imagen completa (un rectángulo en la máscara) para que nunca falte una orilla de tinta.
   - Las "diferencias" salen de una semilla fija: se pinta igual cada vez.
   Sin JavaScript (o si nadie llama a preparar) las pinceladas originales muestran la M completa.
   Medidas en unidades de la imagen; sin pathLength ni vector-effect (fallan en iPhone). Todo son animaciones del
   navegador programadas de una vez: se pueden congelar en cualquier momento (cuadro por cuadro, videos). */
(function () {
  'use strict';
  var NS = 'http://www.w3.org/2000/svg';
  var TRAZO = 'cubic-bezier(0.42, 0, 0.3, 1)';          // cae, acelera y frena en la esquina (sin cola larga)
  var REMATE = 'cubic-bezier(0.2, 0.55, 0.25, 1)';      // latigazo: sale rápido y se suelta
  var SUELTA = 'cubic-bezier(0.3, 0.15, 0.2, 1)';       // sigue con el impulso de la anterior y frena suave al levantar

  function azar(semilla) {
    var s = semilla % 2147483647 || 1;
    return function () { s = (s * 16807) % 2147483647; return (s - 1) / 2147483646; };
  }
  function largo(q) {
    var L = 0;
    for (var i = 1; i < q.length; i++) L += Math.hypot(q[i].x - q[i - 1].x, q[i].y - q[i - 1].y);
    return L;
  }

  // Una pincelada (camino central + grosor) → manojo de cerdas paralelas que cubren el mismo ancho
  function hacerCerdas(p, rnd) {
    var W = parseFloat(p.getAttribute('stroke-width')) || 100, R = W / 2;
    var L = p.getTotalLength(), N = Math.max(10, Math.ceil(L / 12)), c = [], i;
    for (i = 0; i <= N; i++) { var pt = p.getPointAtLength((L * i) / N); c.push({ x: pt.x, y: pt.y }); }
    var dir = c.map(function (pt, j) {
      var a = c[Math.max(0, j - 1)], b = c[Math.min(N, j + 1)], dx = b.x - a.x, dy = b.y - a.y, m = Math.hypot(dx, dy) || 1;
      return { x: dx / m, y: dy / m };
    });
    var K = Math.max(12, Math.round(W / 9)), cerdas = [];                // muchas y finas, como una brocha real
    for (var k = 0; k < K; k++) {
      var u = (k / (K - 1)) * 2 - 1;                                     // -1 una orilla · 0 centro · 1 la otra orilla
      var o = u * R * 0.86 + (rnd() - 0.5) * (W / K) * 0.8;              // separación del centro
      var w = (W / K) * (2 + rnd() * 1.2);                               // grosor: se enciman, sin huecos
      var ext = Math.sqrt(Math.max(0, R * R - o * o)) * 0.85;            // en las puntas se alarga como la punta redonda
      var q = c.map(function (v, j) { return { x: v.x - dir[j].y * o, y: v.y + dir[j].x * o }; });
      var d0 = dir[0], d1 = dir[N];
      q.unshift({ x: q[0].x - d0.x * ext, y: q[0].y - d0.y * ext });
      q.push({ x: q[q.length - 1].x + d1.x * ext, y: q[q.length - 1].y + d1.y * ext });
      var el = document.createElementNS(NS, 'path');
      el.setAttribute('d', 'M' + q.map(function (v) { return v.x.toFixed(1) + ' ' + v.y.toFixed(1); }).join('L'));
      el.setAttribute('stroke-width', w.toFixed(1));
      var Lc = largo(q) + 2;
      // Escondida: el trazo visible termina antes del inicio (también su punta redonda)
      el.style.strokeDasharray = Lc + ' ' + (Lc + w * 2);
      el.style.strokeDashoffset = Lc + w;
      cerdas.push({ el: el, L: Lc, w: w, u: Math.abs(u), r1: rnd(), r2: rnd() });
    }
    cerdas.geo = { c: c, dir: dir, W: W };                               // el camino, para el relieve de la luz
    return cerdas;
  }

  // Deja la imagen lista (escondida) para pintarse. Devuelve la "obra" o null si el navegador no puede.
  function preparar(svg, semilla) {
    if (svg._brocha) return svg._brocha;
    var trazos = Array.prototype.slice.call(svg.querySelectorAll('.mt-brocha__t'));
    var mask = svg.querySelector('mask');
    if (!trazos.length || !mask || !trazos[0].getTotalLength || !trazos[0].animate) return null;
    var rnd = azar(semilla || 20261018);
    var obra = {
      svg: svg,
      trazos: trazos.map(function (p) {
        var cerdas = hacerCerdas(p, rnd);
        cerdas.forEach(function (c) { p.parentNode.insertBefore(c.el, p); });
        return { L: p.getTotalLength(), remate: p.hasAttribute('data-remate'), suelta: p.hasAttribute('data-suelta'), sale: parseFloat(p.getAttribute('data-sale')) || 0, cerdas: cerdas, geo: cerdas.geo };
      })
    };
    trazos.forEach(function (p) { p.style.display = 'none'; });
    var lleno = document.createElementNS(NS, 'rect');
    ['x', 'y', 'width', 'height'].forEach(function (a) { lleno.setAttribute(a, mask.getAttribute(a) || (a.length > 1 ? '100%' : '0')); });
    lleno.setAttribute('fill', '#fff');
    lleno.style.opacity = '0';
    mask.appendChild(lleno);
    obra.lleno = lleno;
    svg._brocha = obra;
    return obra;
  }

  // Pinta la obra. op.inicio (ms de espera) · op.velocidad (1 = normal). Devuelve en qué ms termina la tinta.
  function pintar(obra, op) {
    op = op || {};
    var vel = op.velocidad || 1, t = op.inicio || 0, fin = 0, previo = null;
    obra.trazos.forEach(function (tr) {
      var d;
      if (tr.remate) {
        d = Math.max(110, Math.min(150, tr.L * 0.3)) / vel;
        if (previo) t = previo.t + previo.d * (previo.remate ? 0.65 : 0.95) + 25 / vel;   // levanta la brocha y remata
      } else {
        d = Math.max(170, Math.min(270, tr.L * 0.26)) / vel;
        if (tr.suelta) d *= 1.3;                                                        // se va soltando: un poco más pausada
        if (previo) t = previo.t + previo.d * (tr.sale || 0.66);                        // sale mientras la anterior frena: sin pausas
      }
      tr.cerdas.forEach(function (c) {
        // punta irregular; la orilla, un poco atrás (al soltar la brocha, más: la punta queda deshilachada)
        var lag = d * ((tr.suelta ? 0.09 : 0.045) * Math.pow(c.u, 1.5) + 0.055 * c.r1);
        var dc = d * (0.94 + 0.1 * c.r2);
        c.el.animate([{ strokeDashoffset: c.L + c.w }, { strokeDashoffset: 0 }],
          { duration: dc, delay: t + lag, easing: tr.remate ? REMATE : tr.suelta ? SUELTA : TRAZO, fill: 'both' });
        fin = Math.max(fin, t + lag + dc);
      });
      previo = { t: t, d: d, remate: tr.remate };
    });
    obra.lleno.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 140, delay: fin - 60, fill: 'both' });
    return fin;
  }

  function caja(tag, css) { var e = document.createElement(tag); e.style.cssText = css; return e; }

  // Relieve de la pintura: hebras que siguen la dirección de cada pincelada (las crestas que deja una brocha), de
  // distinto grosor y brillo, cortadas a pedazos y apenas onduladas, más zonas anchas de brillo desparejo (la pintura
  // no tiene el mismo grosor en todos lados) y un brillo parejo muy tenue. Cada pincelada TAPA las hebras de las
  // anteriores donde se enciman (como la pintura real: la de arriba cubre), así no se forma una cuadrícula. Semilla fija.
  var nRelieve = 0;
  function relieve(svg, obra, oscuro) {
    var rnd = azar(9137), color = oscuro ? '#0e0e0e' : '#ffffff', id = 'mt-relieve-' + (++nRelieve);
    var defs = document.createElementNS(NS, 'defs'), g = document.createElementNS(NS, 'g');
    function nuevo(tag, attrs, padre) {
      var e = document.createElementNS(NS, tag);
      for (var k in attrs) e.setAttribute(k, attrs[k]);
      (padre || g).appendChild(e);
      return e;
    }
    function camino(tr, o, onda, fase) {
      var c = tr.geo.c, dir = tr.geo.dir;
      return 'M' + c.map(function (v, j) {
        var oj = o + onda * Math.sin(j * 0.21 + fase) + onda * 0.5 * Math.sin(j * 0.53 + fase * 2.3);
        return (v.x - dir[j].y * oj).toFixed(1) + ' ' + (v.y + dir[j].x * oj).toFixed(1);
      }).join('L');
    }
    svg.appendChild(defs);
    svg.appendChild(g);
    nuevo('rect', { x: -60, y: -60, width: 1044, height: 1105, fill: color, opacity: oscuro ? 0 : 0.16 });
    obra.trazos.forEach(function (tr, i) {
      // lo que tapan las pinceladas que vienen después
      var mk = nuevo('mask', { id: id + '-' + i, maskUnits: 'userSpaceOnUse', x: -60, y: -60, width: 1044, height: 1105 }, defs);
      nuevo('rect', { x: -60, y: -60, width: 1044, height: 1105, fill: '#fff' }, mk);
      obra.trazos.slice(i + 1).forEach(function (sig) {
        nuevo('path', { d: camino(sig, 0, 0, 0), fill: 'none', stroke: '#000', 'stroke-width': (sig.geo.W * 0.8).toFixed(0), 'stroke-linecap': 'round' }, mk);
      });
      var gt = nuevo('g', { mask: 'url(#' + id + '-' + i + ')' });
      var R = tr.geo.W / 2, K = Math.round(tr.geo.W / 4.5), k, patron, s;
      // zonas anchas de brillo desparejo
      for (k = 0; k < 4; k++) {
        patron = [];
        for (s = 0; s < 3; s++) patron.push(Math.round(80 + rnd() * 260), Math.round(40 + rnd() * 160));
        nuevo('path', { d: camino(tr, (rnd() * 2 - 1) * R * 0.6, 6, rnd() * 6), fill: 'none', stroke: color, 'stroke-linecap': 'round',
          'stroke-width': Math.round(R * (0.25 + rnd() * 0.35)), 'stroke-opacity': ((0.05 + rnd() * 0.08) * (oscuro ? 0.3 : 1)).toFixed(3),
          'stroke-dasharray': patron.join(' '), 'stroke-dashoffset': Math.round(rnd() * 300) }, gt);
      }
      // crestas de las cerdas
      for (k = 0; k < K; k++) {
        patron = [];
        for (s = 0; s < 4; s++) patron.push(Math.round(50 + rnd() * 220), Math.round(8 + rnd() * 70));
        nuevo('path', { d: camino(tr, (rnd() * 2 - 1) * R * 0.98, 1.5 + rnd() * 3.5, rnd() * 6), fill: 'none', stroke: color,
          'stroke-linecap': 'round', 'stroke-width': (0.8 + Math.pow(rnd(), 2.2) * 6).toFixed(2),
          'stroke-opacity': ((0.1 + Math.pow(rnd(), 1.6) * 0.9) * (oscuro ? 0.28 : 1)).toFixed(3),
          'stroke-dasharray': patron.join(' '), 'stroke-dashoffset': Math.round(rnd() * 300) }, gt);
      }
    });
  }

  // Una capa que deja ver "contenido" solo donde pasa la luz: la franja es una MÁSCARA suave que baja en diagonal;
  // adentro, el contenido se mueve al revés exacto, así se queda quieto sobre la M (solo se anima transform).
  function capaDeLuz(padre, contenido, inicio, DUR, curva) {
    var a = function (x) { return 'rgba(0,0,0,' + x + ')'; };
    var perfil = 'linear-gradient(180deg,' + a(0) + ' 26%,' + a(0.12) + ' 36%,' + a(0.5) + ' 44%,' + a(1) + ' 50%,' +
      a(0.5) + ' 56%,' + a(0.12) + ' 64%,' + a(0) + ' 74%)';
    var banda = caja('span', 'position:absolute;left:-40%;right:-40%;top:0;height:100%;-webkit-mask:' + perfil + ';mask:' + perfil +
      ';transform:rotate(-16deg) translateY(-76%)');
    var fijo = caja('span', 'position:absolute;left:22.2222%;width:55.5556%;top:0;height:100%;transform:translateY(76%) rotate(16deg)');
    fijo.appendChild(contenido);
    banda.appendChild(fijo);
    padre.appendChild(banda);
    var t = { duration: DUR, delay: inicio, easing: curva, fill: 'both' };
    banda.animate([{ transform: 'rotate(-16deg) translateY(-76%)' }, { transform: 'rotate(-16deg) translateY(76%)' }], t);
    fijo.animate([{ transform: 'translateY(76%) rotate(16deg)' }, { transform: 'translateY(-76%) rotate(16deg)' }], t);
  }

  // LUZ REAL (videos): la luz no es una raya encima del logo; se queda en la pintura. Al pasar, prende las crestas de
  // las cerdas (destellos finos y cortados que siguen cada pincelada) sobre un brillo suave. En tinta blanca, la luz
  // rasante marca los surcos con sombras finas y deja un resplandor tenue alrededor de la M.
  function luzReal(cont, src, inicio, op) {
    var oscuro = !!op.oscuro, DUR = op.duracion || 1300, curva = 'cubic-bezier(0.33, 0.1, 0.4, 0.95)';
    var m = 'url("' + src + '") center / 100% 100% no-repeat';
    var luz = caja('span', 'position:absolute;inset:0;pointer-events:none;-webkit-mask:' + m + ';mask:' + m);
    luz.className = 'mt-brocha__luz';
    luz.setAttribute('aria-hidden', 'true');
    var svg = document.createElementNS(NS, 'svg');
    svg.setAttribute('viewBox', '0 0 924 985');
    svg.setAttribute('preserveAspectRatio', 'none');
    // un desenfoque mínimo: la luz sobre pintura no tiene bordes de navaja
    svg.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;overflow:visible;opacity:' + Math.min(1, (op.intensidad || 1) * 0.65) +
      ';filter:blur(' + Math.max(0.3, cont.getBoundingClientRect().width * 0.0011).toFixed(2) + 'px)';
    relieve(svg, op.obra, oscuro);
    capaDeLuz(luz, svg, inicio, DUR, curva);
    cont.appendChild(luz);
    if (oscuro) {                                                        // resplandor alrededor de la tinta blanca
      var halo = caja('span', 'position:absolute;inset:0;pointer-events:none');
      halo.className = 'mt-brocha__luz';
      var img = caja('img', 'position:absolute;inset:0;width:100%;height:100%;opacity:0.7;filter:blur(' +
        Math.max(2, cont.getBoundingClientRect().width * 0.025).toFixed(1) + 'px)');
      img.src = src; img.alt = '';
      capaDeLuz(halo, img, inicio, DUR, curva);
      cont.insertBefore(halo, cont.firstChild);
    }
    return inicio + DUR;
  }

  // Franja de luz que le pega desde arriba y baja en diagonal por la tinta, como un reflejo (recortada a la forma de
  // la imagen). cont: la caja de la imagen (position: relative). op.oscuro: imagen blanca → la franja es una sombra.
  // op.intensidad: qué tanto brilla (1 = como en la tienda). op.duracion: ms que tarda en bajar (1300 = como en la tienda).
  // op.forma 'real' + op.obra: la luz realista sobre las cerdas (luzReal).
  function brillo(cont, src, inicio, op) {
    op = op || {};
    if (op.forma === 'real' && op.obra) return luzReal(cont, src, inicio, op);
    var luz = document.createElement('span'), f = document.createElement('span');
    var m = 'url("' + src + '") center / 100% 100% no-repeat';
    luz.className = 'mt-brocha__luz';
    luz.setAttribute('aria-hidden', 'true');
    luz.style.cssText = 'position:absolute;inset:0;pointer-events:none;-webkit-mask:' + m + ';mask:' + m;
    var c = op.oscuro ? '14, 14, 14' : '255, 255, 255', k = (op.oscuro ? 0.48 : 1) * (op.intensidad || 1);
    // op.forma 'fina' (videos): centro delgado y brillante con un halo muy suave, como reflejo en algo lacado
    var perfil = op.forma === 'fina'
      ? [[0, 37], [0.03, 42], [0.1, 45.5], [0.25, 48.3], [0.46, 50], [0.25, 51.7], [0.1, 54.5], [0.03, 58], [0, 63]]
      : [[0, 24], [0.07, 34], [0.24, 43], [0.46, 50], [0.24, 57], [0.07, 66], [0, 76]];
    var paradas = perfil.map(function (s) {
      return 'rgba(' + c + ', ' + Math.min(0.95, s[0] * k).toFixed(3) + ') ' + s[1] + '%';
    });
    f.style.cssText = 'position:absolute;left:-40%;right:-40%;top:0;height:100%;transform:rotate(-16deg) translateY(-76%);' +
      'background:linear-gradient(180deg, ' + paradas.join(', ') + ')';
    luz.appendChild(f);
    cont.appendChild(luz);
    var DUR = op.duracion || 1300;
    f.animate([{ transform: 'rotate(-16deg) translateY(-76%)' }, { transform: 'rotate(-16deg) translateY(76%)' }],
      { duration: DUR, delay: inicio, easing: 'cubic-bezier(0.33, 0.1, 0.4, 0.95)', fill: 'both' });
    return inicio + DUR;
  }

  window.MTBrocha = { preparar: preparar, pintar: pintar, brillo: brillo };
})();
